import cn from 'clsx';
import { DateTagLabel } from "./DataTag.styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DateTag = function DateTag(_ref) {
  var label = _ref.label,
    date = _ref.date,
    isExpired = _ref.isExpired,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(' tw-flex tw-flex-col', className),
    children: [/*#__PURE__*/_jsx(DateTagLabel, {
      className: "tw-font-body5 tw-bg-neutral-light-100 tw-pt-0.4 tw-pb-1.2 tw-px-1.2 tw-rounded-0.4 tw-text-neutral-light-700 tw-text-center",
      children: label
    }), /*#__PURE__*/_jsx("span", {
      className: cn('tw-font-subtitle5 tw-py-0.4 tw-px-1.2 tw-relative tw-rounded-0.4 tw-text-neutral-light-100 tw-z-2 tw-bottom-1 tw-uppercase tw-text-center', isExpired ? 'tw-bg-on-hold-400' : 'tw-bg-primary-light-400'),
      children: date
    })]
  });
};